<div id="modal-content-wrapper">
  <form #f="ngForm" (ngSubmit)="submit()">
    <div class="modal-header justify-content-center">
      <h4 class="title">{{ config.title }}</h4>
    </div>
    <div class="modal-body">
      <!-- Enbaled/Disabled State -->
      <div *ngIf="config.state">
        <div>
          <label>Update State</label>
          <input class="checkbox-inline" name="stateToggle" type="checkbox" [(ngModel)]="state.toggleEnabled" />
        </div>
        <div class="form-group" *ngIf="state.toggleEnabled">
          <button
            *ngIf="state.enabled"
            type="button"
            class="btn btn-success btn-icon btn-sm margin-left"
            (click)="state.enabled = false"
            ngbTooltip="Click do disable all"
            placement="right"
          >
            <fa-icon [icon]="['fal','user']"></fa-icon>
          </button>
          <button
            *ngIf="!state.enabled"
            type="button"
            class="btn btn-warning btn-icon btn-sm margin-left"
            (click)="state.enabled = true"
            ngbTooltip="Click do enable all"
            placement="right"
          >
            <fa-icon [icon]="['fal','user-slash']"></fa-icon>
          </button>
          <div class="info">
            <span *ngIf="state.enabled"> All selected entries will be enabled. </span>
            <span *ngIf="!state.enabled"> All selected entries will be disabled. </span>
          </div>
        </div>
      </div>

      <!-- Roles -->
      <div>
        <div>
          <label>Update Roles</label>
          <input class="checkbox-inline" name="rolesToggle" type="checkbox" [(ngModel)]="state.toggleRoles" />
        </div>
        <div class="form-group" *ngIf="state.toggleRoles">
          <role-selector
            ngModel
            name="roles"
            [roles]="roles"
            (onSelect)="state.roles = $event"
            class="form-control"
            [ngClass]="{ 'is-invalid': !isValidRoles() }"
          >
          </role-selector>
        </div>
      </div>

      <!-- Expiration -->
      <div *ngIf="!config.duration || !state.toggleDuration">
        <div>
          <label>Update Expiration</label>
          <input class="checkbox-inline" name="expirationToggle" type="checkbox" [(ngModel)]="state.toggleExpiration" />
        </div>
        <div class="form-group" *ngIf="state.toggleExpiration">
          <div class="datepicker-container">
            <input
              class="form-control datetimepicker"
              placeholder="yyyy-mm-dd"
              [(ngModel)]="state.expiration"
              name="dp"
              #dp="ngbDatepicker"
              (click)="dp.toggle()"
              [ngModelOptions]="{updateOn:'blur'}"
              autocomplete="off"
              ngbDatepicker
            />
          </div>
        </div>
      </div>

      <!-- Duration -->
      <div *ngIf="config.duration && !state.toggleExpiration">
        <div>
          <label>Update Duration</label>
          <input class="checkbox-inline" name="durationToggle" type="checkbox" [(ngModel)]="state.toggleDuration" />
        </div>
        <div class="form-group" *ngIf="state.toggleDuration">
          <duration-picker [(value)]="state.duration"></duration-picker>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="modal.dismiss('cancel')">Cancel</button>
      <button type="submit" class="btn btn-success" [disabled]="!f.form.valid || !isValid()">Submit</button>
    </div>
  </form>
</div>
